export default __webpack_public_path__ + "static/media/Jalisco-Logo-Grande.1b874e27.png";